import { useCallback } from 'react'

import { createPersistedPreference } from '@/lib/hooks/createPersistedPreference'

export type NavLayout = 'sidebar' | 'toolbar'

const layoutPreference = createPersistedPreference<NavLayout>({
  key: 'titan.nav-layout',
  fallback: 'sidebar',
  parse: (raw) =>
    raw === 'sidebar' || raw === 'toolbar' ? (raw as NavLayout) : undefined,
})

export const setNavLayout = layoutPreference.set

/** Which primary navigation chrome the user prefers. */
export const useNavLayout = (): {
  layout: NavLayout
  isSidebar: boolean
  setLayout: (layout: NavLayout) => void
  toggleLayout: () => void
} => {
  const [layout, setLayout] = layoutPreference.usePreference()

  const toggleLayout = useCallback(
    () => setLayout(layout === 'sidebar' ? 'toolbar' : 'sidebar'),
    [layout, setLayout]
  )

  return { layout, isSidebar: layout === 'sidebar', setLayout, toggleLayout }
}
